import { escapeRegExp, isEmpty, isNumber, upperFirst } from 'lodash'

import {
  create,
  evaluateDependencies,
  addDependencies,
  subtractDependencies,
  multiplyDependencies,
  divideDependencies,
} from 'mathjs'

const { add, subtract, multiply, divide } = create({
  addDependencies,
  subtractDependencies,
  multiplyDependencies,
  divideDependencies,
})

// evaluateDepenendencies does not seem to be bringing in all the required dependencies for
// multiplication and division, so we explicitly add them into the instance
const math = create({ evaluateDependencies })
math.import({ add, subtract, multiply, divide }, { override: true })

export default {
  methods: {
    calculation() {
      let calc = this.calculationText
      this.measureObjects.forEach((measureObject) => {
        calc = calc.replace(measureObject.regexp, `${measureObject.subFormula}`)
      })
      return calc
    },

    measureObject(name, attributePath, func) {
      return {
        name,
        subFormula: `${func}(${attributePath})`,
        regexp: new RegExp(escapeRegExp(`[${name}]`), 'g'),
      }
    },
  },

  computed: {
    validFormula() {
      let calc = this.calculationText
      this.measureRegExps.forEach((measureRegExp) => {
        calc = calc.replace(measureRegExp, ' 1 ')
      })

      try {
        return isNumber(math.evaluate(calc))
      } catch (err) {
        return false
      }
    },

    measureNames() {
      return this.measureObjects.map((measureObject) => {
        return measureObject.name
      })
    },

    measureObjects() {
      return this.allMeasures.flatMap((measure) => {
        if (isEmpty(measure.subOptions)) {
          return [this.measureObject(measure.name, measure.attributePath, 'count')]
        }
        return measure.subOptions.map((subOption) => {
          return this.measureObject(
            `${measure.name} (${upperFirst(subOption.attributeValue)})`,
            measure.attributePath,
            subOption.attributeValue,
          )
        })
      })
    },

    measureRegExps() {
      return this.measureObjects.map((measureObject) => {
        return measureObject.regexp
      })
    },
  },
}
